{
  "iframeWaitingMessage": "기다려 주셔서 감사합니다.조금만 더...",
  "otherOrganizations": "다른 조직",
  "solutionIframe": "주요 컨텐츠",
  "unloadPromptMessage": "계속하시겠습니까?"
}
